import {TableConfig, TableConfigRaw} from 'src/js/model/table_config';

const CONFIGURATION_CONFIG = 'config';
const CONFIGURATION_GRID = 'grid';
const CONFIGURATION_HELP_MESSAGE = 'helpMessage';
const CONFIGURATION_DISABLE_EXPORT = 'disableExport';
const CONFIGURATION_RELOADABLE = 'reloadable';
const CONFIGURATION_CAPTION = 'caption';

export interface ListConfigRaw {
  disableExport: boolean;
  dataSource: string[];
  helpMessage: string;
  caption: string;
  reloadable: boolean;
  grid: TableConfigRaw;
}

export class ListConfig {
  private readonly rawData: Partial<ListConfigRaw>;

  private readonly id: string | undefined;

  private readonly loaded: boolean;

  private readonly gridConfig: TableConfig | undefined;

  constructor(rawData: Partial<ListConfigRaw> = {}, id = undefined) {
    this.rawData = {...rawData};
    this.id = id;
    this.loaded = false;
    this.gridConfig = undefined;

    if (
      this.rawData &&
      this.rawData[CONFIGURATION_CONFIG] &&
      this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_GRID]
    ) {
      this.gridConfig = new TableConfig(
        this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_GRID],
        id
      );
      this.loaded = true;
    }
  }

  getId() {
    return this.id;
  }

  getGridConfig() {
    return this.gridConfig;
  }

  getDisableExport() {
    return this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_DISABLE_EXPORT];
  }

  getHelpMessage() {
    return this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_HELP_MESSAGE];
  }

  getReloadable() {
    return this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_RELOADABLE];
  }

  getCaption() {
    return this.rawData[CONFIGURATION_CONFIG] &&
      this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_CAPTION]
      ? this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_CAPTION]
      : '';
  }

  isLoaded() {
    return this.loaded;
  }
}
